
export enum AllocationManagerType {
    Level1Manager = 1,
    Level2Manager = 2,
    HRAssistant = 3,
    HRAssistantManager = 4,
}